// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.r-button {
  display: flex;
  flex-direction: row;
  padding: 5px 12px; /* 16:9 ratio rounded to 1/10 pixel. */
  border: 0;
  border-radius: 3px;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  min-width: 35px;
  min-height: 35px;
  box-shadow: 0 1px 5px 0 rgb(0 0 0 / 20%),
    0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%);
  transition: box-shadow 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  background-color: white;
  cursor: pointer !important;
}

  .r-button:focus {
    outline: none;
  }

  .r-button:active {
    box-shadow: none;
  }

  .r-button--primary {
    color: var(--color-grayscale-1);;
    background-color: var(--btn-color-primary-0);
  }

  .r-button--secondary {
    color: var(--color-grayscale-1);
    background-color: var(--btn-color-secondary-0);
  }

  .r-button--disabled {
    box-shadow: none;
    color: var(--color-grayscale-5);
    background-color: var(--color-grayscale-3);
  }

  /* Layout */

  .r-button-layout--rtl {
    flex-direction: row-reverse;
  }

  /* Variants */

  /* Outlined */

  .r-button-type-outlined {
      background: none;
      border: solid 1px currentcolor;
      box-shadow: none;
    }

  .r-button-type-outlined--primary {
        color: var(--btn-color-primary-0);
      }

  .r-button-type-outlined--secondary {
        color: var(--btn-color-secondary-0);
      }

  .r-button-type-outlined--disabled {
        border-color: var(--color-grayscale-5);
      }

  /* Texxt */

  .r-button-type-text {
      background: none;
      box-shadow: none;
    }

  .r-button-type-text--primary {
        color: var(--btn-color-primary-0);
      }

  .r-button-type-text--secondary {
        color: var(--btn-color-secondary-0);
      }

  .r-button-type-text--disabled {
        /* Set to none because the default --disabled sets background color. */
        background: none;
      }

  /* icon spacer */

  .r-button > div {
    width: 8px;
    height: 8px;
  }

  /*  SVG icon */

  .r-button > svg {
    height: 18px;
    width: 18px;
    fill: currentcolor;
  }
`, "",{"version":3,"sources":["webpack://./app/components/deprecatedTookit/Button/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB,EAAE,sCAAsC;EACzD,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB;iEAC+D;EAC/D,4DAA4D;EAC5D,uBAAuB;EACvB,0BAA0B;AAoF5B;;EAlFE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,+BAA+B;IAC/B,4CAA4C;EAC9C;;EAEA;IACE,+BAA+B;IAC/B,8CAA8C;EAChD;;EAEA;IACE,gBAAgB;IAChB,+BAA+B;IAC/B,0CAA0C;EAC5C;;EAEA,WAAW;;EACX;IACE,2BAA2B;EAC7B;;EAEA,aAAa;;EAEX,aAAa;;EACb;MACE,gBAAgB;MAChB,8BAA8B;MAC9B,gBAAgB;IAalB;;EAXE;QACE,iCAAiC;MACnC;;EAEA;QACE,mCAAmC;MACrC;;EAEA;QACE,sCAAsC;MACxC;;EAGF,UAAU;;EACV;MACE,gBAAgB;MAChB,gBAAgB;IAclB;;EAZE;QACE,iCAAiC;MACnC;;EAEA;QACE,mCAAmC;MACrC;;EAEA;QACE,sEAAsE;QACtE,gBAAgB;MAClB;;EAIJ,gBAAgB;;EAChB;IACE,UAAU;IACV,WAAW;EACb;;EAEA,cAAc;;EACd;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;EACpB","sourcesContent":[".r-button {\n  display: flex;\n  flex-direction: row;\n  padding: 5px 12px; /* 16:9 ratio rounded to 1/10 pixel. */\n  border: 0;\n  border-radius: 3px;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  min-width: 35px;\n  min-height: 35px;\n  box-shadow: 0 1px 5px 0 rgb(0 0 0 / 20%),\n    0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%);\n  transition: box-shadow 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n  background-color: white;\n  cursor: pointer !important;\n\n  &:focus {\n    outline: none;\n  }\n\n  &:active {\n    box-shadow: none;\n  }\n\n  &--primary {\n    color: var(--color-grayscale-1);;\n    background-color: var(--btn-color-primary-0);\n  }\n\n  &--secondary {\n    color: var(--color-grayscale-1);\n    background-color: var(--btn-color-secondary-0);\n  }\n\n  &--disabled {\n    box-shadow: none;\n    color: var(--color-grayscale-5);\n    background-color: var(--color-grayscale-3);\n  }\n\n  /* Layout */\n  &-layout--rtl {\n    flex-direction: row-reverse;\n  }\n\n  /* Variants */\n  &-type {\n    /* Outlined */\n    &-outlined {\n      background: none;\n      border: solid 1px currentcolor;\n      box-shadow: none;\n\n      &--primary {\n        color: var(--btn-color-primary-0);\n      }\n\n      &--secondary {\n        color: var(--btn-color-secondary-0);\n      }\n\n      &--disabled {\n        border-color: var(--color-grayscale-5);\n      }\n    }\n\n    /* Texxt */\n    &-text {\n      background: none;\n      box-shadow: none;\n\n      &--primary {\n        color: var(--btn-color-primary-0);\n      }\n\n      &--secondary {\n        color: var(--btn-color-secondary-0);\n      }\n\n      &--disabled {\n        /* Set to none because the default --disabled sets background color. */\n        background: none;\n      }\n    }\n  }\n\n  /* icon spacer */\n  & > div {\n    width: 8px;\n    height: 8px;\n  }\n\n  /*  SVG icon */\n  & > svg {\n    height: 18px;\n    width: 18px;\n    fill: currentcolor;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
